import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { Market } from 'types/Market'
import RequestStatus from 'components/RequestStatus'
import type { ArrayResponse } from 'components/AdvancedTable/AdvancedTable.types'
import { useParams } from 'react-router-dom'
import type { PrizeGroup } from 'types/Prize'
import PrizeEditFields from './PrizeEditFields'
import { Paper } from '@mui/material'
import useQueryGet from 'hooks/useQueryGet'
import { AddDocumentForm } from './partials/add-document'
import { UpdatePrizesForm } from './partials/update-prizes-file'

const PrizeEditForm = (): JSX.Element => {
  const { t } = useTranslation()
  const params = useParams<{ id: string }>()

  const { data: prizeData, isLoading: prizeIsLoading } = useQueryGet<PrizeGroup>({
    queryKey: ['prize-group-data', `prize-${params.id ?? ''}`],
    endpoint: `prizes/groups/${params.id ?? ''}`,
  })

  const { data, isLoading } = useQueryGet<ArrayResponse<Market>>({
    queryKey: ['prize-markets'],
    endpoint: 'markets',
    queryOptions: { cacheTime: 0 },
  })

  if (data === undefined || 'error' in data) {
    return <RequestStatus data={data} isLoading={isLoading} />
  }
  if (prizeData === undefined || 'error' in prizeData) {
    return <RequestStatus data={prizeData} isLoading={prizeIsLoading} />
  }

  return (
    <>
      <Typography variant="h4" component="h1" mb={2}>
        {t('common.editField', { field: 'Prize' })}
      </Typography>
      <Box display="flex" flexDirection="column" gap={4}>
        <Paper sx={{ p: 4 }}>{params.id !== undefined ? <PrizeEditFields prizeData={prizeData} /> : null}</Paper>

        {params.id !== undefined ? <AddDocumentForm prizeGroupId={params.id} fileFromAPI={prizeData.file} /> : null}

        {params.id !== undefined ? <UpdatePrizesForm prizeGroupId={params.id} /> : null}
      </Box>
    </>
  )
}

export default PrizeEditForm
